module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'contractors',
        preventClearOnCancel: true,
        updateTabTitleForFieldCodes: {
            companyName: true
        },
        updateTabTitleTabContentLocator: '<< base_tabStrip_tabContent',
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_contractors': true
        },
    },
}